import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from '../../../styles/constants';

const ITEM_HEIGHT = 35;
export const buildMenuProps = (theme, minWidth) => ({
	anchorOrigin: {
		vertical: 'bottom',
		horizontal: 'left'
	},
	transformOrigin: {
		vertical: 'top',
		horizontal: 'left'
	},
	getContentAnchorEl: null,
	MenuListProps: {
		style: {
			padding: 0
		}
	},
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 6.5,
			minWidth: minWidth ? minWidth : DIMENSIONS.FILTERS_PANEL_WIDTH - theme.spacing(5),
			boxShadow: theme.shadows[2]
		}
	}
});

export const useStyles = makeStyles(theme => ({
	formControl: {
		width: props => (props.minWidth ? 'auto' : DIMENSIONS.FILTERS_PANEL_WIDTH - theme.spacing(4)),
		minWidth: props => (props.minWidth ? props.minWidth : 190),
		margin: 0
	},
	menuItem: {
		minHeight: ITEM_HEIGHT,
		height: ITEM_HEIGHT,
		paddingLeft: props => (props.multiple ? 0 : 8)
	},
	listItemText: {
		overflowX: 'hidden',
		margin: 0
	}
}));
